import React from 'react';
import './About.css';

function About() {
  return (
    <div className="about">
      <div className="page-header">
        <div className="container">
          <h1>About Us</h1>
          <p>Connecting Talent with Opportunity</p>
        </div>
      </div>

      <div className="container">
        <section className="about-section">
          <div className="about-content">
            <h2>Our Mission</h2>
            <p>
              CampusRecruit is dedicated to bridging the gap between talented students and 
              leading companies. We strive to create a seamless platform that facilitates 
              campus recruitment, making it easier for students to find their dream jobs 
              and for companies to discover exceptional talent.
            </p>
          </div>
        </section>

        <section className="about-section">
          <div className="about-content">
            <h2>Our Vision</h2>
            <p>
              To become the most trusted and comprehensive campus recruitment platform, 
              empowering millions of students across India to build successful careers 
              while helping companies build strong, diverse teams.
            </p>
          </div>
        </section>

        <section className="about-section">
          <div className="about-content">
            <h2>What We Offer</h2>
            <div className="offer-grid">
              <div className="offer-item">
                <h3>For Students</h3>
                <ul>
                  <li>Access to top placement opportunities</li>
                  <li>Profile creation and management</li>
                  <li>Application tracking system</li>
                  <li>Career guidance and resources</li>
                </ul>
              </div>
              <div className="offer-item">
                <h3>For Companies</h3>
                <ul>
                  <li>Access to qualified student pool</li>
                  <li>Streamlined recruitment process</li>
                  <li>Customized drive management</li>
                  <li>Analytics and reporting tools</li>
                </ul>
              </div>
              <div className="offer-item">
                <h3>For Colleges</h3>
                <ul>
                  <li>Placement drive management</li>
                  <li>Student performance tracking</li>
                  <li>Company partnerships</li>
                  <li>Placement statistics dashboard</li>
                </ul>
              </div>
            </div>
          </div>
        </section>

        <section className="about-section">
          <div className="about-content">
            <h2>Our Values</h2>
            <div className="values-grid">
              <div className="value-item">
                <h3>Integrity</h3>
                <p>We maintain the highest standards of honesty and transparency in all our operations.</p>
              </div>
              <div className="value-item">
                <h3>Innovation</h3>
                <p>We continuously improve our platform with cutting-edge technology and features.</p>
              </div>
              <div className="value-item">
                <h3>Excellence</h3>
                <p>We are committed to delivering exceptional service to all our stakeholders.</p>
              </div>
              <div className="value-item">
                <h3>Inclusivity</h3>
                <p>We believe in equal opportunities for all students regardless of background.</p>
              </div>
            </div>
          </div>
        </section>

        <section className="about-section">
          <div className="about-content">
            <h2>Our Team</h2>
            <p>
              Our team consists of experienced professionals from the education and technology 
              sectors, working together to create the best possible experience for students, 
              companies, and colleges.
            </p>
          </div>
        </section>
      </div>
    </div>
  );
}

export default About;

